import { memo } from "../../../../../../../motion-utils@12.23.6/external/motion-utils/dist/es/memo.mjs";
const supportsScrollTimeline = /* @__PURE__ */ memo(() => window.ScrollTimeline !== void 0);
export {
  supportsScrollTimeline
};
